import { jsx as i, jsxs as f } from "../../_virtual/jsx-runtime.mjs";
import { useRef as d, useCallback as u, useMemo as v, useEffect as h } from "react";
import C from "../../depend/youtube-player/dist/index.mjs";
import s from "../../depend/classnames/index.mjs";
import { closeIconWrap as I, closeIcon as P, youtubePopup as b, youtubePopupBody as N, youtubePopupContent as x, loadingWrap as V, youtubeVideoContainer as w, youtubeVideoBox as E, videoIframe as p } from "./css/ReoYoutube.css.mjs";
import l from "../../depend/youtube-player/dist/constants/PlayerStates.mjs";
import m from "../../packages/basic/dist/es/components/ReoIcon/ReoIcon.mjs";
import "../../packages/basic/dist/es/components/ReoBalloon/ReoBalloon.mjs";
import "../../packages/basic/dist/es/components/ReoButton/index.mjs";
import "../../packages/basic/dist/es/components/ReoCheckbox/index.mjs";
import "../../packages/basic/dist/es/components/ReoLink/ReoLink.mjs";
import "../../packages/basic/dist/es/_virtual/jsx-runtime.mjs";
import "../../packages/basic/dist/es/depend/classnames/index.mjs";
import "../../packages/basic/dist/es/assets/css/globalTheme.mjs";
import "../../packages/basic/dist/es/assets/css/themes/template/templateMap.mjs";
import "../../packages/basic/dist/es/components/ReoTabs/ReoTabTree.mjs";
import "../../packages/basic/dist/es/components/ReoInput/index.mjs";
import "../../packages/basic/dist/es/components/ReoSelect/ReoSelect.mjs";
import g from "../../packages/basic/dist/es/components/ReoPopup/ReoPopup.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/UploadList.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/const.mjs";
import "../../packages/basic/dist/es/depend/rc-upload/es/Upload.mjs";
import "../../packages/basic/dist/es/components/ReoUpload/DraggedUploadList.mjs";
import "../../packages/basic/dist/es/components/ReoAccordion/AccordionItem.mjs";
import "../../packages/basic/dist/es/depend/swiper/swiper-react.mjs";
import "../../packages/basic/dist/es/Basic/LoadingBar/LoadingBar.mjs";
import "../../packages/basic/dist/es/components/ReoMessage/ReoMessage.mjs";
import "../../packages/basic/dist/es/components/ReoForm/index.mjs";
const k = (o, e) => {
  switch (o.data) {
    case l.ENDED:
      e.onEnd && e.onEnd(o);
      break;
    case l.PLAYING:
      e.onPlay && e.onPlay(o);
      break;
    case l.PAUSED:
      e.onPause && e.onPause(o);
      break;
    case l.VIDEO_CUED:
      e.onCued && e.onCued();
      break;
  }
}, D = (o, e) => {
  e.videoId ? o.loadVideoById(e.videoId).catch((r) => {
    throw new Error(r);
  }) : e.videoIds && o.loadPlaylist(e.videoIds).catch((r) => {
    throw new Error(r);
  });
}, R = (o, e, r, a) => {
  const t = C(o, e);
  return t.on("ready", (c) => {
    var n;
    (n = r.events) != null && n.ready ? r.events.ready(c) : D(t, r);
  }), t.on("stateChange", (c) => {
    var n;
    (n = r.events) != null && n.stateChange ? r.events.stateChange(c) : k(c, a);
  }), t;
}, A = (o) => {
  const e = d(o.options), r = d({
    videoId: "",
    playerVars: {}
  }), a = d(null), t = d(null), c = u(() => {
    r.current.playerVars = {
      rel: 0,
      loop: 1,
      autoplay: 0,
      start: 0,
      end: 0,
      ...e.current.playerVars
    }, e.current.videoId ? r.current.videoId = e.current.videoId : e.current.videoIds && (r.current.playerVars = {
      ...r.current.playerVars,
      playlist: e.current.videoIds.join(",")
    });
  }, []), n = u(() => {
    t.current && e.current.index !== void 0 && t.current.playVideoAt(e.current.index).catch((y) => {
      throw new Error(y);
    });
  }, []);
  return h(() => {
    (e.current.videoId || e.current.videoIds) && a.current && r.current && !t.current && (c(), window.youtubeClass = "reo-youtube", t.current = R(a.current, r.current, e.current, o)), o.options.index !== void 0 && o.options.index !== e.current.index && (e.current.index = o.options.index, n());
  }, [n, o, c]), /* @__PURE__ */ i(
    "div",
    {
      id: "video-iframe",
      className: p,
      ref: a
    }
  );
}, ae = (o) => {
  const e = d(o.options), r = u(() => {
    o.onClose();
  }, [o]), a = v(
    () => /* @__PURE__ */ i(
      "div",
      {
        onClick: r,
        className: I,
        children: /* @__PURE__ */ i(
          m,
          {
            className: P,
            name: "icon-icon-error-4",
            color: "#ffffff",
            width: 10
          }
        )
      }
    ),
    [r]
  );
  return /* @__PURE__ */ f(
    g,
    {
      open: o.open,
      destroyOnClose: !0,
      className: s(b, o.className),
      mask: !0,
      contentStyle: {
        padding: 0
      },
      onClose: r,
      bodyClassName: N,
      childrenMaxHeight: "none",
      contentClassName: x,
      closeIconNode: a,
      children: [
        /* @__PURE__ */ i("div", { className: s(V, o.loadingClassName), children: /* @__PURE__ */ i(
          m,
          {
            name: "icon-icon-loading-2",
            width: "60",
            color: "#fff"
          }
        ) }),
        /* @__PURE__ */ i(
          "div",
          {
            className: s(w, o.videoClassName),
            id: "youtube-video-container",
            children: /* @__PURE__ */ i(
              "div",
              {
                id: "youtube-video-box",
                className: E,
                children: /* @__PURE__ */ i(A, { options: e.current })
              }
            )
          }
        )
      ]
    }
  );
};
export {
  A as ReoYoutube,
  ae as default
};
//# sourceMappingURL=ReoYoutube.mjs.map
